import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    userDetails: null,
}

const userSlice = createSlice({
    name: "userSlice",
    initialState,
    reducers: {
        setUserDetails: (state, action) => {
            state.userDetails = action.payload;
            return state;
        },
        removeUserDetails: (state, action) => {
            state.userDetails = null;
            return state;
        }
    }

});

export const { setUserDetails, removeUserDetails } = userSlice.actions;
export default userSlice;